import { type Settings } from "@repo/ui";

export const getCurrencyCode = (general: Settings["general"]) => {
  return general?.currency?.currency_code ?? "EUR";
};
